import { ApolloLink } from '@apollo/client/link/core';
import { RetryLink } from '@apollo/client/link/retry';
import { ref } from '@vue/composition-api';
import { useNetwork } from '@/hooks/network';
import { logger as globalLogger } from '@/logger';

export const isRetrying = ref(false);

const logger = globalLogger.getLogger('apollo/retry');

const DownLink = new RetryLink({
  attempts: (count, operation, error) => {
    let max = 5;

    if (canRetryForever(operation.operationName)) {
      max = Infinity;
    }

    const retry = !(count >= max) && !!error;

    if (count > 1 && retry) {
      isRetrying.value = useNetwork().isOnline.value;
    }

    logger.trace({ count, operation, error, max, retry });

    return retry;
  },
  delay: {
    initial: 1_000,
    jitter: true,
    max: 15_000,
  },
});

const UpLink = new ApolloLink((operation, forward) =>
  forward(operation).map((data) => {
    if (isRetrying.value) {
      isRetrying.value = false;
      logger.trace('Retry cleanup');
    }

    return data;
  }),
);

export const RetryLinks = [DownLink, UpLink];

export function canRetryForever(operationName: string): boolean {
  return [
    'SubmitChallengeResult',
    'RequestChallenges',
    'RequestChallenge',
  ].includes(operationName);
}
